import {
  fetchBubbles,
  fetchFirstNDemoGlance,
  fetchFirstNGlance,
  filterCategories,
} from "./../utils/glance";
import {
  getBubbleIds,
  getCategories,
  getCovidData,
  getDefaultRoposoStories,
  getGlanceById,
  getGlanceIds,
  getHotspotData,
  getInsurancePackages,
  getLanguages,
} from "../services";

const parseCookies = (cookieString) => {
  return cookieString.split(";").reduce((acc, cookie) => {
    const [key, value] = cookie.split("=").map((c) => c.trim());
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {});
};

export const getInitialPropsForHome = async function({ req, res }) {
  try {
    const _glancesWithIds = (await getGlanceIds({ nodeRequest: req })) || [];
    const ids = _glancesWithIds.map((g) => g.glanceId);
    const glances = await fetchFirstNGlance({
      nodeRequest: req,
      count: 10,
      ids: ids,
    });
    const cookies = req.headers.cookie || "";
    const parsedCookies = parseCookies(cookies);
    return {
      ids: ids,
      glances,
      disaplayOnboarding: !parsedCookies.onboarded,
    };
  } catch (err) {
    console.error(err);
  }
  return { glances: [], ids: [] };
};

export const getInitialPropsForDemo = async function({ req }) {
  try {
    const _glancesWithIds = (await getGlanceIds({ nodeRequest: req })) || [];
    const ids = _glancesWithIds.map((g) => g.glanceId);
    const glances = await fetchFirstNDemoGlance({
      nodeRequest: req,
      count: 5,
      ids: ids,
    });
    return {
      ids: ids,
      glances,
    };
  } catch (err) {
    console.error(err);
  }
  return { glances: [], ids: [] };
};

export const getInitialPropsForGlance = async function({ req, query }) {
  try {
    const _glancesWithIds = (await getGlanceIds({ nodeRequest: req })) || [];
    let ids = _glancesWithIds.map((g) => g.glanceId);
    const { id } = query;
    const params = req.query;
    ids = ids.filter((_id) => _id !== id);

    const firstGlance = await getGlanceById({
      nodeRequest: req,
      id: id,
    });
    const _glances = await fetchFirstNGlance({
      nodeRequest: req,
      count: 4,
      ids: ids,
    });
    const glances = [firstGlance, ..._glances];
    return {
      ids: ids,
      glances,
      params: params,
    };
  } catch (err) {
    console.error(err);
  }
  return { glances: [], ids: [], params: undefined };
};

export const getInitialPropsForCustomGlance = async function({ req, query }) {
  try {
    const _glancesWithIds = (await getGlanceIds({ nodeRequest: req }, 1)) || [];
    const ids = _glancesWithIds.map((g) => g.glanceId);
    const _glances = await fetchFirstNGlance(
      {
        nodeRequest: req,
        count: ids.length,
        ids: ids,
      },
      1
    );
    const glances = [..._glances];
    return {
      ids: ids,
      glances,
    };
  } catch (err) {
    console.error(err);
  }
  return { glances: [], ids: [] };
};

export const getInitialPropsForCategory = async function({ req }) {
  const allCategories = await getCategories({ nodeRequest: req });
  const categories = filterCategories([...allCategories]);
  return {
    categories,
  };
};

export const getInitialPropsForInsurance = async function({ req }) {
  const packages = req
    ? await getInsurancePackages({ nodeRequest: req })
    : await getInsurancePackages();
  const query = req.query;
  return { packages, query };
};

export const getInitialPropsForLanguage = async function({ req }) {
  const languages = await getLanguages({ nodeRequest: req });
  return {
    languages,
  };
};

export const getInitialPropsForCovid = async function({ req, query }) {
  const data = req
    ? await getCovidData({ nodeRequest: req })
    : await getCovidData();
  return {
    data,
    query,
  };
};

export const getInitialPropsForHotspot = async function({ req, query }) {
  const data = req
    ? await getHotspotData({ nodeRequest: req })
    : await getHotspotData();
  return {
    data,
    query,
  };
};

export const getInitialPropsForStories = async function({ req, res, query }) {
  try {
    const { id } = query;
    const _glancesWithIds =
      (await getBubbleIds({ nodeRequest: req, id: id })) || [];
    const bubbleids = _glancesWithIds.map((g) => g.id);
    const glances = await fetchBubbles({
      nodeRequest: req,
      ids: bubbleids,
    });
    return {
      glances,
      query: req.query,
    };
  } catch (err) {
    console.error(err);
  }
  return { glances: [] };
};

/**
 * getInitialProps is used to asynchronously fetch some data, which then populates props.
 * @param {pathname, query, asPath, req, res, err} context
 * getInitialProps receives a single argument called context, it's an object with the following properties:
 * pathname - Current route. That is the path of the page in /pages
 * query - Query string section of URL parsed as an object
 * asPath - String of the actual path (including the query) shown in the browser
 * req - HTTP request object (server only)
 * res - HTTP response object (server only)
 * err - Error object if any error is encountered during the rendering
 *
 * @return {paginationInfo, data}
 * it will return the response of /partner/v1/channel/default/stories
 */

export const getInitialPropsForRoposoWeb = async function({ req, res, query }) {
  let defaultStories;
  try {
    defaultStories = await getDefaultRoposoStories({
      nodeRequest: req,
    });
  } catch (err) {
    if (err.response && err.response.status === 401) {
      defaultStories = await getDefaultRoposoStories({
        nodeRequest: req,
        tokenExpire: true,
      });
    }
  }
  return defaultStories;
};
